import { ReactNode } from "react";
import { Card as RNECard, CardProps, useTheme } from "react-native-elements";

export function Card(props: CardProps & { children?: ReactNode }) {
  const theme = useTheme();
  return (
    <RNECard
      {...props}
      containerStyle={[
        { backgroundColor: theme.theme.colors.background },
        props?.containerStyle,
      ]}
    >
      {props.children}
    </RNECard>
  );
}
